import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import TopBanner from '../../../components/topBanner/topBanner'
import imgBanner from "../../../images/banner/banner-tin-tuc.jpg"
import Title_center from '../../../components/title/TitleCenter'
import { useParams, useNavigate } from 'react-router-dom'
import { normalizeLang } from '../../../utils/localeDataLoader';
import { getNewsByLanguage } from '../../../apis/news';
import { getNewsCategoriesByLanguage } from '../../../apis/newsCategories';
import { normalizeUploadedImageUrl } from '../../../apis/uploadImage';

function DetailNews() {
    const { t, i18n } = useTranslation();
    const { slug } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState();
    const [categoryTitle, setCategoryTitle] = useState('');
    const [newsId, setNewsId] = useState(null);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        const load = async () => {
            try {
                const languageCode = normalizeLang(i18n.language);
                const [newsList, categories] = await Promise.all([
                    getNewsByLanguage(languageCode),
                    getNewsCategoriesByLanguage(languageCode),
                ]);
                const found = newsList.find((item) => item.slug === slug)
                    ?? (newsId !== null ? newsList.find((item) => item.id === newsId) : undefined);
                if (found) {
                    const basePath = languageCode === 'en' ? '/news' : '/tin-tuc';
                    const expectedPath = `${basePath}/${found.slug}`;
                    const currentPath = window.location.pathname.replace(/\/$/, '');
                    if (currentPath !== expectedPath) {
                        navigate(expectedPath, { replace: true });
                    }
                    setData(found);
                    setNewsId(found.id);
                    const category = categories.find((c) => c.id === found.newsCategoryId);
                    setCategoryTitle(category ? category.title : '');
                }
            } catch (error) {
                console.error('Failed to load news detail:', error);
            }
        };
        load();
    }, [i18n.language, slug]);

    return (
        <div className='DetailNews' style={{ paddingBottom: "3rem" }}>
            <TopBanner
                titleCenter={t('news.news')}
                imgBanner={imgBanner}
                pageName={categoryTitle}
                text={data ? data.title : ""}
            />
            <div className='layout_container'>
                <Title_center
                    text={data ? data.title : ""}
                />
                <div className="DetailNews-content">
                    {data?.description && (
                        <div className="quill-content">
                            <div
                                dangerouslySetInnerHTML={{ __html: normalizeUploadedImageUrl(data.description) }}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default DetailNews